import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {AmorgRoutes} from './AmorgRoutes';
import { GlobalStyle } from './globalStyles';


// Modal.setAppElement('#root');

export const redirectOnError = false;
export const redirectOnInsufficientPermission = true;

const container = document.getElementById("root");

if (container) {
	const root = createRoot(container);
	root.render(
		<>
			<GlobalStyle />
			<BrowserRouter>
				<AmorgRoutes />
			</BrowserRouter>
		</>
	);
}